import { Staff } from './Staff';
import { Contact } from './Contact';
import { Socifact } from './Facture';


export class Prospect {
    prospectId: number;

    codeClient: string;
    utilisateurs: Staff;
    adresse: string;
    raisonSocial: string;
    signalitique: string;
    ancienClient: boolean;

    createur: string;
    remarque: string;
    site: string;
    fax: string;
    secteur: string;

    color: string;

    status: string;

    paysId: Pays;
    pays: string;
    langue: string;

    nis: string;
    nrc: string;
    nai: string;
    nif: string;
    vatNumber: string;
    rcNumber: string;
    sociFact: string;
    pavillon: string;
    ordre: number;

    devise: string;

    projet: string;
    lastModifiedDate: Date;
    solde: number;
    remarqueFinance: string;
    groupeFinance: string;
    secteurId: Secteur;


    statusjudiciaire: string;
    origineContact: string;
    historique: string;
}
export class Pays {
    paysId: number;
    designationAn: string;
    designationFr: string;
}

export interface Pavillon {
    pavillonId: string;
    color: string;
    designation: string;


}
export class Secteur {
    secteurId: number;
    designation: string;
    designationAn: string;
}
export class Titre {

    titreId: number;
    designation: string;

}
export class Packagesponsor {
    id: number;
    detail: string;
    designation: string;
    l1: string;
    t1: string;
    l2: string;
    t2: string;
    l3: string;
    t3: string;
    l4: string;
    t4: string;
    prospect: Prospect;
    socifact: Socifact;

    companyName: string;
    adresse: string;
    tel: string;
    fax: string;
    mobile: string;

    nom: string;
    prenom: string;
    position: string;
    email: string;
    website: string;

    isSpeaker: string;
    isEnglish: string;
    conditions: string;
    articles: string;





 
}